import { render } from "./shopmaison-banner-collection.vue?vue&type=template&id=6836fef8&scoped=true"
import script from "./shopmaison-banner-collection.vue?vue&type=script&lang=js"
export * from "./shopmaison-banner-collection.vue?vue&type=script&lang=js"

import "./shopmaison-banner-collection.vue?vue&type=style&index=0&id=6836fef8&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6836fef8"]])

export default __exports__